import { render, staticRenderFns } from "./invoice-inquiry.vue?vue&type=template&id=dc5be43e&"
import script from "./invoice-inquiry.vue?vue&type=script&lang=js&"
export * from "./invoice-inquiry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports